var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#FF9900"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 9.25C6 8.81902 6.1712 8.4057 6.47595 8.10095C6.7807 7.7962 7.19402 7.625 7.625 7.625H17.375C17.806 7.625 18.2193 7.7962 18.524 8.10095C18.8288 8.4057 19 8.81902 19 9.25V10.0625H6V9.25ZM6 11.6875V15.75C6 16.181 6.1712 16.5943 6.47595 16.899C6.7807 17.2038 7.19402 17.375 7.625 17.375H17.375C17.806 17.375 18.2193 17.2038 18.524 16.899C18.8288 16.5943 19 16.181 19 15.75V11.6875H6ZM8.4375 13.3125H9.25C9.46549 13.3125 9.67215 13.3981 9.82452 13.5505C9.9769 13.7028 10.0625 13.9095 10.0625 14.125V14.9375C10.0625 15.153 9.9769 15.3597 9.82452 15.512C9.67215 15.6644 9.46549 15.75 9.25 15.75H8.4375C8.22201 15.75 8.01535 15.6644 7.86298 15.512C7.7106 15.3597 7.625 15.153 7.625 14.9375V14.125C7.625 13.9095 7.7106 13.7028 7.86298 13.5505C8.01535 13.3981 8.22201 13.3125 8.4375 13.3125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardIcon);
export default __webpack_public_path__ + "static/media/credit-card-icon.f30336b7c51ac197176e3daf241ba7f9.svg";
export { ForwardRef as ReactComponent };